export function isError<V>(value: V | Error): value is Error {
  return value instanceof Error
}

const networkErrorMessages = new Set([
  'NetworkError when attempting to fetch resource.', // firefox
  'The Internet connection appears to be offline.', // safari 16
  'fetch failed', // undici (Node.js)
  'Network request failed', // another possible message
])

const networkErrorMessageFragments = [
  'Failed to fetch', // chrome - can have domain appended like "Failed to fetch (domain.com)"
  'The user aborted a request.',
  'Load failed', // safari 17+
]

export function isNetworkError(error: unknown): boolean {
  // handle simple string errors immediately
  if (typeof error === 'string') {
    return (
      networkErrorMessages.has(error) ||
      networkErrorMessageFragments.some(fragment => error.includes(fragment))
    )
  }

  // ensure it is an Error object with a string message
  if (!(error instanceof Error) || typeof error.message !== 'string') {
    return false
  }

  // many fetch implementations reject with TypeError, but not all network errors are TypeErrors
  if (error.name !== 'TypeError') {
    return false
  }

  // 1. check exact matches
  if (networkErrorMessages.has(error.message)) {
    return true
  }

  // 2. check partial matches
  if (networkErrorMessageFragments.some(fragment => error.message.includes(fragment))) {
    return true
  }

  return false
}
